import { anonymousClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { router } from "../main"
import { queryClient } from "@/utils/trpc";

const resolveBaseUrl = () => {
	const envUrl = import.meta.env.VITE_BETTER_AUTH_URL?.toString().trim();
	if (envUrl) {
		return envUrl.replace(/\/$/, "");
	}
	if (typeof window !== "undefined") {
		return window.location.origin;
	}
	return "http://localhost:3000";
};

export const authClient = createAuthClient({
	baseURL: resolveBaseUrl(),
	plugins: [anonymousClient()],
});

authClient.$store.listen("$sessionSignal", async (value, oldValue) => {
	await queryClient.invalidateQueries(
		{queryKey: ["session"]}
	);

	router.invalidate();
})